import moment from 'moment'

moment.locale('fr')

